<template>
	<md-card>
		<md-ripple class="ask-text-content">
			<md-card-header class="positiveresponse-outer">
				<router-link :to="`/asks/${ask._id}/request`" class="remove-link">
					<div class="ask-subject" :style="communityStyle">
						<ul class="list-inline mb-0">
							<li>{{$lodash.has(community, 'name') ? community.name + ': ' + (currentAsk.subject ? currentAsk.subject : 'N/A') : (currentAsk.subject ? currentAsk.subject : 'N/A')}}</li>
							<li class="count" v-if="currentAsk.comments.length">{{currentAsk.comments.length}}</li>
						</ul>
					</div>
				</router-link>
				<div :style="communityStyle" class="positiveresponse" > <span v-if="selectedOwner != '' && currentAsk.status != '(7) Closed' && currentAsk.status != '(8) Rejected'">({{selectedOwner}})   &nbsp;&nbsp; </span> {{positiveResponse}} / {{recommendedAdvisors}}</div>
			</md-card-header>
			<md-card-content>
				<div class="md-subhead">
					<div class="row">
						<div class="col-sm-6">
							<ul class="list-unstyled mb-0">
								<li>Status: {{ currentAsk.status }}</li>
								<li>Received: {{ask.createdAt | momentDate }}</li>
                <li>Last Advisor Matched:
                  <span v-if="ask.matchAdviserDate">{{ask.matchAdviserDate | momentDate}}</span>
					        <span v-else>N/A</span>
                </li>
								<li class="ask-dueDate" v-if="ask.dueDate">Due Date: {{ask.dueDate | dateFormat }}</li>
							</ul>
						</div>
						<div class="col-sm-6">
							<ul class="list-unstyled pull-right mb-0">
								<li><span v-if="$lodash.has(createdByMember, 'displayName')">Sender: {{ createdByMember.displayName }}</span></li>
								<li><span v-if="$lodash.has(createdByMember, 'emails')">Email: {{ createdByMember.emails.toString() }}</span></li>
							</ul>
						</div>
					</div>
				</div>
				<hr />
				<p class="mt-10" v-html="nl2br(ask.text)"></p>
			</md-card-content>
			<md-card-actions class="card-actions">
				<div class="form-group asklisting-owner" v-if="term != 'my-request' && currentAsk.status != '(7) Closed' && currentAsk.status != '(8) Rejected'">
					<select class="form-control" @change="assignOwner()" v-model="selectedOwner" name="owner" placeholder="owner" id="owner">
						<option value="">Owner (none)</option>
						<option v-for="(singleOwner) in allOwners" v-bind:key="singleOwner._id" :value="singleOwner.email">{{ singleOwner.email }}</option>
					</select>
				</div>
				<md-button class="md-raised md-round md-accent" v-for="action in availableInteractions1" :interaction="action" :key="action" @click="doInteraction( action )">{{ action }}
				</md-button><md-button class="md-raised md-round capitalize capitalize request-status-btn" v-if="status === 'Pending'" v-on:click="doInteraction('approve')">Super Admin Approval</md-button>
			</md-card-actions>
		</md-ripple>
	</md-card>

</template>
<script>
import API from "../services/API";
export default {
  	props: ["ask", "allOwners", "term"],
  	data() {
    	return {
		  	api: new API(),
		  	currentAsk: this.ask,
		  	createdByMember: {},
		  	community: {},
		  	communityStyle: {
		    	backgroundColor: "white",
		    	color: "black"
		  	},
			status: '',
			positiveResponse: 0,
			recommendedAdvisors: 0,
			allOwner: [],
			selectedOwner: ""
    	};
  	},
  	async created() {
		this.status = this.ask.status;
		this.selectedOwner = this.ask.reserveOwner && this.ask.reserveOwner.email ? this.ask.reserveOwner.email : '';
		const found = this.allOwners.some(el => el.email === this.selectedOwner);
		if (!found) {
			this.selectedOwner = '';
		}
    	await this.loadData();
  	},
  	computed: {
  		availableInteractions: function() {
  			if (this.currentAsk.availableInteractions) {
  				let availableInteractions = this.currentAsk.availableInteractions.slice()
  				availableInteractions.forEach((val, index) => {
	  				if (val.match(/send-connect-email/i)) {
	  					availableInteractions[index] = 'send-response';
	  				}
	  			});
  				return availableInteractions.filter((interaction) => interaction !== 'add-feedback');
  			}
  			return this.currentAsk.availableInteractions;
  		},
		availableInteractions1: function() {
			if (this.currentAsk.availableInteractions) {
				let availableInteractions = this.currentAsk.availableInteractions.slice()
				availableInteractions.forEach((val, index) => {
					if (val.match(/send-connect-email/i)) {
						availableInteractions[index] = 'send-response';
					} else if (val.match(/resolve/i)) {
						availableInteractions[index] = 'close';
					}
				});
				if (this.status === 'Add Tags') {
					return availableInteractions.filter((interaction) => interaction !== 'edit' && interaction !== 'tag');
				} else if (this.status === '(0) New') {
					return availableInteractions.filter((interaction) => interaction !== 'edit');
				} else if (this.status === '(1) Tagged') {
					return availableInteractions.filter((interaction) => interaction !== 'edit' && interaction !== 'reject');
				} else if (this.status === '(2) Matched') {
					return availableInteractions.filter((interaction) => interaction !== 'edit');
				} else if (this.status === '(3) Dispatched' || this.status === '(4) Reminded') {
					return availableInteractions.filter((interaction) => interaction !== 'send-reminder-email');
				} else if (this.status === '(5) Responded') {
					return availableInteractions.filter((interaction) => interaction !== 'send-response' && interaction !== 'get-feedback' && interaction !== 'send-reminder-email');
				} else if (this.status === '(7) Closed') {
					return availableInteractions.filter((interaction) => interaction !== 'add-feedback');
				} else if (this.status === 'In Review' || this.status === 'Reviewed') {
					return availableInteractions.filter((interaction) => interaction);
				} else if (this.status === 'Pending') {
					// return availableInteractions.filter((interaction) => interaction);
					return availableInteractions.filter((interaction) => interaction !== 'approve');
				} else {
					return availableInteractions.filter((interaction) => interaction !== 'add-feedback' && interaction !== 'reject');
				}
			}
			return this.currentAsk.availableInteractions;
  		}
  	},
  	methods: {
    	loadData: async function() {
      		if (this.currentAsk) {
				if (this.ask.createdByMemberID) {
          			this.createdByMember = this.ask.createdByMemberID;
        		}
        		if (this.ask.community) {
          			this.community = this.ask.community;
          			if (this.$lodash.has(this.community, 'customSettings')) {
	            		this.communityStyle.backgroundColor = this.community.customSettings.primaryColor;
              			this.communityStyle.color = this.community.customSettings.secondaryColor;
	        		}
        		}
				var positivecount = 0;
				await this.ask.gives.map(singleGive => {
					if (singleGive.helpaction === 'yes' && singleGive.responseState.currentState === 'Approved') {
						positivecount++;
					}
				});
				this.positiveResponse = positivecount;
				this.recommendedAdvisors = this.ask.recommendedAdvisors.length;
      		}
    	},
    	doInteraction: function(action) {
      		action = action === 'tag' ? 'Add Tags' : action;
			this.$router.push({path: `/asks/${this.ask._id}/request`, query: {action: action}});
		},
    	nl2br (str, replaceMode, isXhtml) {
      		var breakTag = (isXhtml) ? '<br />' : '<br>';
      		var replaceStr = (replaceMode) ? '$1' + breakTag : '$1' + breakTag + '$2';
      		return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
    	},
    	assignOwner: async function() {
			await this.api.post(`asks/${this.ask._id}/assign-owner`, {owner: this.selectedOwner}).then(response => {});
		}
  	}
};
</script>



// WEBPACK FOOTER //
// src/components/AskTile.vue